import { useState } from 'react';
import api from 'api/lcManage';
import LcManageHelpers from 'pages/lcmanage/LcManageHelpers';
import Button from 'components/ui/button';
import Input from 'components/ui/input';
import Form from 'components/ui/form';
import Loader from 'components/ui/loader';
import ModalTitle from '../components/ModalTitle';
import ModalContent from '../components/ModalContent';
import ModalFooter from '../components/ModalFooter';

interface Props {
  callback: ({ data }: { data: any }) => void;
  content: {
    data: any;
  };
}

const EditLocale: React.FC<Props> = ({ callback, content: { data } }) => {
  const [form, setForm] = useState(() => getInitialForm(data));
  const [isLoading, setLoading] = useState(false);

  function getInitialForm(data: any) {
    const template = LcManageHelpers.getTemplate(data);

    if (!template) {
      return {
        ticket: '',
        token: '',
        en: '',
        ru: '',
        es: '',
        fr: '',
      };
    }

    const locale = {
      en: '',
      ru: '',
      es: '',
      fr: '',
    };

    template.texts.forEach((item) => {
      if (item.text) {
        locale[item.lang] = item.text;
      }
    });

    return {
      ...locale,
      ticket: data.ticket_number || '',
      token: data.token || '',
    };
  }

  const changeForm = (key: string, value: string) => {
    setForm((prevForm) => ({ ...prevForm, [key]: value }));
  };

  const sendForm = async () => {
    setLoading(true);
    try {
      const template = LcManageHelpers.getTemplate(data);
      const editedRow = await api.edit({
        id: template ? template.id : undefined,
        token: form.token,
        ticket_number: form.ticket,
        texts: [
          { lang: 'en', text: form.en },
          { lang: 'ru', text: form.ru },
          { lang: 'es', text: form.es },
          { lang: 'fr', text: form.fr },
        ],
      });
      editedRow.customId = data.customId;
      callback({ data: editedRow });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ModalTitle>Edit</ModalTitle>
      <ModalContent>
        <Form onSubmit={sendForm}>
          <Input
            autoFocus
            id='lc-ticket'
            label='Ticket'
            value={form.ticket}
            placeholder='Enter ticket'
            disabled={!data.editable_ticket_number}
            onChange={(e) => changeForm('ticket', e.target.value)}
          />
          <br />
          <Input
            id='lc-token'
            label='Token'
            value={form.token}
            placeholder='Enter token'
            disabled={!data.editable_token}
            onChange={(e) => changeForm('token', e.target.value)}
          />
          <br />
          <Input
            id='lc-en'
            label='En'
            value={form.en}
            placeholder='Enter translation'
            onChange={(e) => changeForm('en', e.target.value)}
          />
          <br />
          <Input
            id='lc-ru'
            label='Ru'
            value={form.ru}
            placeholder='Enter translation'
            onChange={(e) => changeForm('ru', e.target.value)}
          />
          <br />
          <Input
            id='lc-es'
            label='Es'
            value={form.es}
            placeholder='Enter translation'
            onChange={(e) => changeForm('es', e.target.value)}
          />
          <br />
          <Input
            id='lc-fr'
            label='Fr'
            value={form.fr}
            placeholder='Enter translation'
            onChange={(e) => changeForm('fr', e.target.value)}
          />
        </Form>
      </ModalContent>
      <ModalFooter>
        <Button text='Apply' status='success' onClick={sendForm} />
      </ModalFooter>
      {isLoading && <Loader />}
    </>
  );
};

export default EditLocale;
